// extracted by mini-css-extract-plugin
module.exports = {"CompletionFailed":"CompletionFailed_CompletionFailed__2V2hO","CompletionFailed__ErrorMessage":"CompletionFailed_CompletionFailed__ErrorMessage__jWmOO"};